import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import ScrollBtnRef from '../../components/atom/scroll/ScrollBtnRef'
import { useNavigate } from 'react-router-dom'

// components
import Loading from '../../components/atom/loading/Loading'

// constants
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'

// styles
import colors from '../../styles/colors'

const ServiceTerms = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const { fetchData, loading, data, error } = useAxios()
  // const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  // 아이템
  const [serviceItem, setServiceItem] = useState(null)

  // front 있는 파일명
  const [serviceFile, setServiceFile] = useState(null)

  // 스크롤
  const scrollRef = useRef(null)

  const handleScrollUp = () => {
    if (scrollRef?.current) {
      scrollRef.current.contentWindow.scrollBy(0, -300) // 원하는 만큼의 픽셀만큼 스크롤
    }
  }

  const handleScrollDown = () => {
    if (scrollRef?.current) {
      scrollRef.current.contentWindow.scrollBy(0, 300) // 원하는 만큼의 픽셀만큼 스크롤
    }
  }

  // 초기 화면로드
  useEffect(() => {
    getTermDetail('S')
  }, [])

  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData

    switch (resCode) {
      // 성공(데이터 O)
      case TYPE.API_RESPONSE.SUCCESS:
        if (resData) {
          // 목록
          if (Array.isArray(resData)) {
            // 최근 약관 조회
            if (resData[0]?.termsDate) {
              getTermDetail(resData[0].termsDate)
            }
          }
          // 상세
          else {
            const resultArr = resData.termList.filter(
              (e) => e.termsType === 'S',
            )[0]

            const serviceFileValue = `service_${moment(
              resultArr?.termsDate,
            ).format('YYMMDD')}.html`

            setServiceItem(resultArr?.termsContents ?? null)
            setServiceFile(serviceFileValue) // front파일
          }
          break
        } else {
          navigate('/error', { replace: true })
        }
      default:
        break
    }
  }, [data])

  // 약관 상세
  const getTermDetail = (termsType) => {
    if (user) {
      // id 안넣으면 최신으로 조회
      const params = {
        termsType: termsType,
      }

      fetchData(
        constants.API.TERM_LIST,
        'GET', // method
        null, // body
        params, // params
      )
    }
  }

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : serviceItem === serviceFile ? (
        <>
          <Header>서비스 이용약관</Header>
          <Contents>
            <iframe
              ref={scrollRef}
              // src={`${constants.HTML_URL}/${serviceItem}`}
              src={`/termsHtml/${serviceFile}`}
              width="100%"
            />
            <ScrollBtnRef
              onClickUp={() => handleScrollUp()}
              onClickDown={() => handleScrollDown()}
            />
          </Contents>
        </>
      ) : (
        <></>
      )}
    </Container>
  )
}

export default ServiceTerms

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;
  flex: 1;
  /* height: 3000px; */

  @media ${(props) => props.theme.tablet} {
    /* height: 3600px; */
    padding: 40px;
  }
`

const Header = styled.div`
  font-size: 25px;
  color: ${colors.mainG};
  font-weight: bold;
`

const Contents = styled.div`
  margin-top: 54px;
  display: flex;
  padding: 10px 0 0 10px;
  flex: 1;
`
